/**
 * The API reports where a sound is used with raw enum keys, e.g.
 * `{"VOICEMAIL": ["Jane Doe"], "QUEUE": ["Support"]}`. Map them to translations.
 */
const SOUND_USAGE_TYPE_KEYS: Record<string, string> = {
    QUEUE: 'sound.usage.queue',
    REFER: 'sound.usage.refer',
    PROFILE: 'sound.usage.profile',
    PREREFER: 'sound.usage.prerefer',
    VOICEMAIL: 'sound.usage.voicemail',
};

export type SoundUsageMap = Record<string, string[]>;

/**
 * Flattens a usage map into readable rows, e.g. `["Voicemail: Jane Doe"]`.
 * Unknown usage types fall back to the raw key so a new type added on the
 * backend degrades to `NEWTYPE: X` rather than `undefined: X`.
 */
export const flattenSoundUsage = (
    usageMap: SoundUsageMap,
    t: (key: string) => string,
): string[] =>
    Object.entries(usageMap ?? {}).flatMap(([type, names]) =>
        (names ?? []).map(
            (name) =>
                `${SOUND_USAGE_TYPE_KEYS[type] ? t(SOUND_USAGE_TYPE_KEYS[type]) : type}: ${name}`,
        ),
    );
